<template>
    <div class="not-found">
        <h1>404</h1>
        <p>ТАКОЙ СТРАНИЦЫ НЕ СУЩЕСТВУЕТ</p>
        <img src="../sprites/404.gif" alt="">
        <router-link to="/">Вернутся на главную</router-link>
    </div>
</template>
<style scoped>
.not-found {
    width:  80%;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  
    font-family: Arial, sans-serif;
    
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    transition: all 0.3s ease;
  
    text-decoration: none;

    font-size: 20px;
    font-weight: bold;
    color: #007BFF;

    border: 2px solid #007BFF;
    border-radius: 5px;
    padding: 20px;
    transition: background-color 0.3s, color 0.3s, border-color 0.3s;
    text-align: center;
}   

</style>